import { render, staticRenderFns } from "./abstract-detail.vue?vue&type=template&id=e2681262&scoped=true"
import script from "./abstract-detail.vue?vue&type=script&lang=js"
export * from "./abstract-detail.vue?vue&type=script&lang=js"
import style0 from "./abstract-detail.vue?vue&type=style&index=0&id=e2681262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2681262",
  null
  
)

export default component.exports